export const CUSTOMER = 1;
export const BUSINESS = 2;
export const INTERNAL = 3;
export const REPETITIVE_CUSTOMER = 4;
export const REPETITIVE_BUSINESS = 5;

export default Object.freeze({
  CUSTOMER,
  BUSINESS,
  INTERNAL,
  REPETITIVE_CUSTOMER,
  REPETITIVE_BUSINESS
});
